if (!customElements.get('quick-buy')) {
  const formatter = new Intl.NumberFormat(Shopify.locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  function decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value.replace(/%22/g, '"');
  }

  class QuickBuy extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      this.products = this.dataset.productJson ? JSON.parse(this.dataset.productJson) : null;
      this.initialProductId = this.dataset.initialProductId;
      this.selectedProduct = null;

      if (this.products && this.initialProductId) {
        this.selectedProduct = this.products.find(({ id }) => id === this.initialProductId);
      }

      if (this.querySelector('[data-quickbuy-wrapper]')) {
        this.querySelector('[data-main-img]')?.addEventListener('load', () => {
          this.querySelector('[data-quickbuy-wrapper]').style.paddingTop = `${this.querySelector('[data-tile-wrapper]')?.clientHeight + 32}px`;
        });

        var resizeObserver = new ResizeObserver(debounce((entries) => {
          for (const entry of entries) {
            this.querySelector('[data-quickbuy-wrapper]').style.paddingTop = `${this.querySelector('[data-tile-wrapper]')?.clientHeight + 32}px`;
          }
        }, 300));

        resizeObserver.observe(this);

        const observer = new MutationObserver(debounce(observerCallback.bind(this), 300));
        observer.observe(this, { childList: true, subtree: true });

        function observerCallback(mutationList) {
          for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
              this.querySelector('[data-quickbuy-wrapper]').style.paddingTop = `${this.querySelector('[data-tile-wrapper]')?.clientHeight + 32}px`;
            }
          }
        }
      }

      this.watchSwatchOverflow();
      this.addSwatchHoverListeners();
    }

    addSwatchHoverListeners() {
      const tileWrapper = this.querySelector('[data-tile-wrapper]');
      if (!tileWrapper) return;

      this.querySelectorAll('[data-quickbuy-action="product-select"]').forEach((swatch) => {
        const productId = swatch.dataset.productId;
        const product = this.products?.find(p => p.id === productId);
        if (!product) return;

        const nextImage = product.images[product.images.findIndex(x => x.src === product.featured_image) + 1];
        const nextFeaturedImageRoot = nextImage?.src?.split('&width')[0] ?? product.featured_image?.split('&width')[0];
        const hoverMedia = product.hover_media?.trim() ? decodeHtml(product.hover_media) : null;

        swatch.addEventListener('mouseenter', () => {
          const existingSecondary = this.querySelector('[data-secondary-img]');
          if (!existingSecondary) return;
          // original = existingSecondary.cloneNode(true);

          if (hoverMedia && hoverMedia.includes('<video')) {
            existingSecondary.outerHTML = `
              <div data-secondary-img class="absolute top-0 left-0 w-full h-full transition duration-300 opacity-0 block object-contain object-center mix-blend-multiply md:group-hover:opacity-100">
                ${hoverMedia}
              </div>
            `;
          } else {
            existingSecondary.outerHTML = `
              <img data-secondary-img class="absolute top-0 left-0 w-full h-full transition duration-300 opacity-0 block object-contain object-center mix-blend-multiply md:group-hover:opacity-100" src="${nextFeaturedImageRoot}&width=800" srcset="${nextFeaturedImageRoot}?v=1654632888&width=352 352w">
            `;
          }
        });

        swatch.addEventListener('mouseleave', () => {
          const existingSecondary = this.querySelector('[data-secondary-img]');
          let hoverMedia = this.selectedProduct.hover_media?.trim();
          if (hoverMedia) hoverMedia = decodeHtml(hoverMedia);
          const featured_image_root = this.selectedProduct.featured_image?.split('&width')[0] ?? '';
          const nextImage = this.selectedProduct.images[this.selectedProduct.images.findIndex(x => x.src === this.selectedProduct.featured_image) + 1];
          const next_featured_image_root = nextImage?.src?.split('&width')[0] ?? featured_image_root;
   
          if (hoverMedia && hoverMedia.includes('<video')) {
            existingSecondary.outerHTML = `
              <div data-secondary-img class="absolute top-0 left-0 w-full h-full transition duration-300 opacity-0 block object-contain object-center mix-blend-multiply md:group-hover:opacity-100">
                ${hoverMedia}
              </div>
            `;
          } else {
            existingSecondary.src = next_featured_image_root;
            existingSecondary.srcset = next_featured_image_root;
          }
        });
      });
    }
    
    watchSwatchOverflow() {
      const swatchWrappers = this.querySelectorAll('[data-swatch-wrapper]');
      const checkOverflow = (el) => {
        const scrollLeft = el.scrollLeft;
        const maxScrollLeft = el.scrollWidth - el.clientWidth;

        el.classList.toggle('is-scrollable-left', scrollLeft > 0);
        el.classList.toggle('is-scrollable-right', scrollLeft < maxScrollLeft);
      };

      swatchWrappers.forEach(wrapper => {
        checkOverflow(wrapper);
        // Fix to allow swatches to scroll when displayed within a swiper
        ['mousewheel', 'touchmove'].forEach(eventType => wrapper.addEventListener(eventType, (e) => {
          e.stopPropagation()
        }));
        wrapper.addEventListener('scroll', () => checkOverflow(wrapper));
        window.addEventListener('resize', debounce(() => checkOverflow(wrapper), 200));
      });
    }

    addDelegatedClickListeners() {
      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-quickbuy-action]');
        if (!clickedElement) return;

        const { quickbuyAction: action, productId } = clickedElement.dataset;

        switch (action) {
          case 'product-select':
            [...this.querySelectorAll('[data-quickbuy-action="product-select"]')].forEach((el) => {
              if (!el.isSameNode(clickedElement)) {
                el.classList.remove('active');
                return;
              }
              el.classList.add('active');
            });

            if (productId) {
              this.selectedProduct = this.products.find(({ id }) => id === productId);
            }

            if (!this.selectedProduct) return;

            this.querySelectorAll('[data-product-url]').forEach(a => a.href = this.selectedProduct.url);
            
            [...this.querySelectorAll('[data-show]')].forEach((el) => {
              if (el.dataset.show === this.selectedProduct.id) {
                el.style.display = null;
                return;
              }
              el.style.display = 'none';
            });

            this.querySelector('[data-product-price]').innerHTML = `
              <intersection-loader 
                data-url="/products/${this.selectedProduct.handle}" 
                data-section-id="product-tile-discount-price"
                class="min-h-[18px]"
              >
                <span></span>
              </intersection-loader/>
            `;

            const featured_image_root = this.selectedProduct.featured_image?.split('&width')[0] ?? '';
            const nextImage = this.selectedProduct.images[this.selectedProduct.images.findIndex(x => x.src === this.selectedProduct.featured_image) + 1];
            const next_featured_image_root = nextImage?.src?.split('&width')[0] ?? featured_image_root;

            let secondaryImageContainer = this.querySelector('[data-secondary-img]');
            if (!secondaryImageContainer) {
              const newSecondaryImg = document.createElement('img');
              newSecondaryImg.setAttribute('data-secondary-img', '');
              newSecondaryImg.className = 'absolute top-0 left-0 w-full h-full transition duration-300 opacity-0 block object-contain object-center mix-blend-multiply md:group-hover:opacity-100';
              this.querySelector('[data-image-wrapper]')?.appendChild(newSecondaryImg);
              secondaryImageContainer = newSecondaryImg;
            }
                        

            let hoverMedia = this.selectedProduct.hover_media?.trim();
            if (hoverMedia) hoverMedia = decodeHtml(hoverMedia);

            this.querySelector('[data-main-img]').src = `${featured_image_root}&width=800`;
            this.querySelector('[data-main-img]').srcset = `${featured_image_root}?v=1654632888&width=352 352w`;
            this.querySelector('[data-main-img]').classList.add('md:group-hover:opacity-0');

            if (hoverMedia && hoverMedia.includes('<video')) {
              secondaryImageContainer.outerHTML = `
                <div data-secondary-img class="absolute top-0 left-0 w-full h-full transition duration-300 opacity-0 block object-contain object-center mix-blend-multiply md:group-hover:opacity-100">
                  ${hoverMedia}
                </div>
              `;
            } else {
              secondaryImageContainer.src = next_featured_image_root;
            }

            if (!this.querySelector('[data-quickbuy-variants]')) return;
            this.querySelector('[data-quickbuy-variants]').innerHTML = this.selectedProduct.variants.map((variant) => `
              <li class="relative aspect-square border border-current w-11 h-11 ${variant.available ? '' : 'opacity-50'}">
                <form method="post" action="/cart/add" id="product_form_${this.selectedProduct.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <select name="id" class="sr-only" aria-hidden="true">
                    <option value="${variant.id}"></option>
                  </select>
                  <button ${variant.available ? '' : 'disabled="true"'} class="flex items-center justify-center absolute h-full w-full rounded-none transition duration-300 md:hover:enabled:text-primaryLight md:hover:enabled:bg-primaryDark disabled:cursor-not-allowed" type="submit">
                    ${variant.title.split('/')[0]}
                  </button>
                </form>
                ${variant.available ? '' : '<span class="absolute bottom-0 transform -rotate-45 h-px bg-secondaryDark origin-bottom-left" style="width: calc(100% * 1.414)" aria-hidden="true"></span>'}
              </li>
            `).join('');
            break;

          case 'show-variants':
            this.open();
            break;

          case 'hide-variants':
            this.close();
            break;

          default:
            break;
        }
      });
    }

    open() {
      this.isOpen = true;
      const quickBuyAction = this.querySelector('[data-quickbuy-action="show-variants"]');
      const hideType = quickBuyAction.dataset.hideType;
      hideType === 'opacity' ? quickBuyAction.style.opacity = 0 : quickBuyAction.style.display = 'none';
      [...this.querySelectorAll('[data-quickbuy-variants]')]?.forEach(el => el.style.display = null);
      this.querySelector('button[type="submit"]:not(:disabled)').focus();
      this.addEventListener('mouseleave', this.close, { once: true });
    }

    close() {
      this.isOpen = false;
      this.querySelector('[data-quickbuy-action="show-variants"]').style.opacity = 0;
      this.querySelector('[data-quickbuy-action="show-variants"]').style.display = null;
      [...this.querySelectorAll('[data-quickbuy-variants]')]?.forEach(el => el.style.display = 'none');

      setTimeout(() => {
        this.querySelector('[data-quickbuy-action="show-variants"]').style.opacity = null;
      }, 300);
    }
  }

  customElements.define('quick-buy', QuickBuy);
}
